module.exports = {
    "": "DEPARTURE ONLY",
    "Menu mobile": "Menu mobile",
    "Logout": "Logout",
    "Choose a destination": "Choose a destination",
    "Where You're Staying": "Where You're Staying",
    "Loading": "Loading",
    "Customize your experience": "Customize your experience",
    "Home": "Home",
    "Transfers": "Transfers",
    "All Tours": "All Tours",
    "Trending & Reviews": "Trending & Reviews",
    "Specials": "Specials",
    "Wish List": "Wish List",
    "Dining": "Dining",
    "Shopping": "Shopping",
    "Contact": "Contact",
    "My Account": "My Account",
    "Tours": "Tours",
    "Get to your hotel with style, select or search your hotel to get our best selection of airport-hotel transfer services. Air conditioned comfortable coaches, minivans or private vehicles will be waiting to take you to your destination.": "Get to your hotel with style, select or search your hotel to get our best selection of airport-hotel transfer services. Air conditioned comfortable coaches, minivans or private vehicles will be waiting to take you to your destination.",
    "Select your hotel": "Select your hotel",
    "Please select your hotel from the list of available options so we can provide an accurate list of transfer options for your location.": "Please select your hotel from the list of available options so we can provide an accurate list of transfer options for your location.",
    "Select Airport Option": "Select Airport Option",
    "Arrival Airport": "Arrival Airport",
    "Departure Airport": "Departure Airport",
    "Select Below": "Select Below",
    "Note:": "Note:",
    "If the system shows arrival & departure but round trip is not available, it means that they have to be booked separately.": "If the system shows arrival & departure but round trip is not available, it means that they have to be booked separately.",
    "TRANSFERS FOUND:": "TRANSFERS FOUND:",
    " Loading...": " Loading...",
    "Loading...": "Loading...",
    "Type your Hotel Name": "Type your Hotel Name",
    "Need help?": "Need help?",
    "About": "About",
    "Privacy Policy": "Privacy Policy",
    "About us": "About us",
    "Account": "Account",
    "Terms and condition": "Terms and condition",
    "Discover": "Discover",
    "Wishlist": "Wishlist",
    "Settings": "Settings",
    "Tours Reviews": "Tours Reviews",
    "Terms & Conditions": "Terms & Conditions",
    "Special Offers": "Special Offers",
    "Empty Cart": "Empty Cart",
    "CHECKOUT": "CHECKOUT",
    "We make good vacations great": "We make good vacations great",
    "PLACE YOUR ORDER": "PLACE YOUR ORDER",
    "Search Tours": "Search Tours",
    "Search terms": "Search terms",
    "Type your search terms": "Type your search terms",
    "Destination": "Destination",
    "Search Transfers": "Search Transfers",
    "Select": "Select",
    "Search now": "Search now",
    "Hotel Name": "Hotel Name",
    "CHANGE": "CHANGE",
    "Seleccione": "Seleccione",
    "NOT CERTAIN": "NOT CERTAIN",
    "ALL AREAS": "ALL AREAS",
    "No Hotels found": "No Hotels found",
    "Select Arrival Airport": "Select Arrival Airport",
    "Rates are per": "Rates are per",
    "in": "in",
    "DESCRIPTION": "DESCRIPTION",
    "ARRIVAL ONLY": "ARRIVAL ONLY",
    "(NOT AVAILABLE)": "(NOT AVAILABLE)",
    "ROUND TRIP": "ROUND TRIP",
    "DEPARTURE ONLY": "DEPARTURE ONLY",
    "NOT AVAILABLE": "NOT AVAILABLE",
    "WELCOME": "WELCOME",
    "TO": "TO",
    "<span class='orange_t'>TOUR</span><span class='blue_t'> REVIEWS</span>": "<span class='orange_t'>TOUR</span><span class='blue_t'> REVIEWS</span>",
    "See What's Hot And What Other vacations have to say": "See What's Hot And What Other vacations have to say",
    "See Tours": "See Tours",
    "Read Reviews": "Read Reviews",
    "\"...the Royal Swim was perfect for us ...<br />we wanted a great experience and we got it... \"": "\"...the Royal Swim was perfect for us ...<br />we wanted a great experience and we got it... \"",
    "BUY 2 Tours AND GET a 3<sup>rd</sup> ONE FREE": "BUY 2 Tours AND GET a 3<sup>rd</sup> ONE FREE",
    "<span class='orange_t'>GET</span><span class='yellow_t'> THE</span><span class='blue_t'> APP</span>": "<span class='orange_t'>GET</span><span class='yellow_t'> THE</span><span class='blue_t'> APP</span>",
    "<span class='orange_t'>FREE</span><span class='blue_t'> TOUR</span>": "<span class='orange_t'>FREE</span><span class='blue_t'> TOUR</span>",
    "See How!": "See How!",
    "Vacation Offers & Features": "Vacation Offers & Features",
    "Download Now!": "Download Now!",
    "\"FREE CALLS to the concierge before & during vacation<br />Transfers, Tours, and more!\"": "\"FREE CALLS to the concierge before & during vacation<br />Transfers, Tours, and more!\"",
    "AIRPORT TRANSFERS ~ GET TO YOUR HOTEL IN STYLE!": "AIRPORT TRANSFERS ~ GET TO YOUR HOTEL IN STYLE!",
    "Our <span class='blue_text'>Destinations</span>": "Our <span class='blue_text'>Destinations</span>",
    "Discover our Top tours <span>now</span>": "Discover our Top tours <span>now</span>",
    "Know our places and be happy": "Know our places and be happy",
    "See our best tour places at Totoura": "See our best tour places at Totoura",
    "Read more": "Read more",
    "Some <span class='blue_text'>good</span> reasons": "Some <span class='blue_text'>good</span> reasons",
    "VACATIONER REVIEWS": "VACATIONER REVIEWS",
    "We have the best reasons to travel": "We have the best reasons to travel",
    "Products & Prices Guaranteed!": "Products & Prices Guaranteed!",
    "FROM": "FROM",
    "From": "From",
    "Details": "Details",
    "Review": "Review",
    "Add Cart": "Add Cart",
    "Add to wishlist": "Add to wishlist",
    "Top Rated": "Top Rated",
    "Delete from wishlist": "Delete from wishlist",
    "Searching": "Searching",
    "Click on tours you like to build a Wish List": "Click on tours you like to build a Wish List",
    "Tour & ACTIVITES in": "Tour & ACTIVITES in",
    "We will look for specials and enter you to win your favorites": "We will look for specials and enter you to win your favorites",
    "Find your Perfect Tour:": "Find your Perfect Tour:",
    "By Category": "By Category",
    "3rd Tour Free": "3rd Tour Free",
    "Land": "Land",
    "Type your search keyword here & press enter key...": "Type your search keyword here & press enter key...",
    "Water": "Water",
    "Cultural": "Cultural",
    "Nightlife": "Nightlife",
    "Adventure": "Adventure",
    "Family": "Family",
    "Select All": "Select All",
    "Unselect All": "Unselect All",
    "founds": "founds",
    "Valid 3rd Tour Free": "Valid 3rd Tour Free",
    "Searching...": "Searching...",
    "Detail": "Detail",
    "No results found...": "No results found...",
    "Name": "Name",
    "Be in Touch": "Be in Touch",
    "Enter Name": "Enter Name",
    "Contact Us!": "Contact Us!",
    "\"Enter Email\"": "\"Enter Email\"",
    "Email": "Email",
    "Message": "Message",
    "Write your message": "Write your message",
    "USA / CANADA": "USA / CANADA",
    "Submit": "Submit",
    "CANCUN / COZUMEL PUERTO VALLARTA / LOS CABOS": "CANCUN / COZUMEL PUERTO VALLARTA / LOS CABOS",
    "Toll Free": "Toll Free",
    "DOMINICAN REPUBLIC": "DOMINICAN REPUBLIC",
    "PUNTA CANA": "PUNTA CANA",
    "For inquiries please email us at": "For inquiries please email us at",
    "or simply fill out the online contact form": "or simply fill out the online contact form",
    "PUERTO PLATA": "PUERTO PLATA",
    "Enter your name": "Enter your name",
    "Enter a valid email": "Enter a valid email",
    "Enter your Message - More than 20 characters": "Enter your Message - More than 20 characters",
    "Arrival": "Arrival",
    "Departure": "Departure",
    "Round": "Round",
    "translate test": "translate test",
    "By agreeing to the Conditions of Use of Totoura?s websites and/or mobile applications Customer agrees to the collection, use and disclosure of its personal information as outlined above.   To the extent provided by applicable law, Customer may request access and correction of its personal information held by TOTOURA by contacting it at the email address set out above.": "By agreeing to the Conditions of Use of Totoura?s websites and/or mobile applications Customer agrees to the collection, use and disclosure of its personal information as outlined above.   To the extent provided by applicable law, Customer may request access and correction of its personal information held by TOTOURA by contacting it at the email address set out above.",
    "Every individual or legal entity (hereafter referred to as the ?Customer?) by the mere fact of accessing, visiting or registering himself/herself in the Web Site, is automatically subject to the present terms and conditions, as well as to its future modifications. The Customer hereby declares and warrants that he/she is over 18 years of age and has the legal capacity and attributions necessary to purchase or hire in his/her own capacity or in behalf of the legal entity that the Customer declares to represent, as well as to order the charges to the credit card which information he/she provides. The parents and tutors are responsible for the purchases or reservations on-line that are made by the children under their responsibility, with or without their prior approval.": "Every individual or legal entity (hereafter referred to as the ?Customer?) by the mere fact of accessing, visiting or registering himself/herself in the Web Site, is automatically subject to the present terms and conditions, as well as to its future modifications. The Customer hereby declares and warrants that he/she is over 18 years of age and has the legal capacity and attributions necessary to purchase or hire in his/her own capacity or in behalf of the legal entity that the Customer declares to represent, as well as to order the charges to the credit card which information he/she provides. The parents and tutors are responsible for the purchases or reservations on-line that are made by the children under their responsibility, with or without their prior approval.",
    "Cancunp": "Cancunp",
    " on or off.": " on or off.",
    "Turn ": "Turn ",
    "Find and tap ": "Find and tap ",
    "Location": "Location",
    "Destiny": "Destiny",
    "Choose the option you want as your default setting.": "Choose the option you want as your default setting.",
    "Location ": "Location ",
    "Chrome.": "Chrome.",
    "At the bottom, click": "At the bottom, click",
    "On your iPhone or iPad, open the settings app.": "On your iPhone or iPad, open the settings app.",
    "Change your default location settings": "Change your default location settings",
    "Site settings ": "Site settings ",
    "Coming Soon": "Coming Soon",
    "No": "No",
    "Recordar Selección": "Recordar Selección",
    "¿Desea utilizar su ubicacion actual como destino?": "¿Desea utilizar su ubicacion actual como destino?",
    "Yes": "Yes",
    "Type your City": "Type your City",
    "On your computer, open Chrome.": "On your computer, open Chrome.",
    " Location.": " Location.",
    "What destination do you want to visit?": "What destination do you want to visit?",
    "Find your next experience": "Find your next experience",
    "USA": "USA",
    "Cookies Policy": "Cookies Policy",
    "Ask before accessing ": "Ask before accessing ",
    "Airport - Hotel Transfer Services": "Airport - Hotel Transfer Services",
    "Location.": "Location.",
    "At the top right, click More ": "At the top right, click More ",
    " Advanced.": " Advanced.",
    "Android": "Android",
    "Let a site know your location": "Let a site know your location",
    "on or off.": "on or off.",
    "Computer": "Computer",
    "If you use Google as your default search engine on your phone, your location is used by default for your searches on Google.": "If you use Google as your default search engine on your phone, your location is used by default for your searches on Google.",
    " Settings": " Settings",
    "By default, Chrome asks you when a site wants to see your location. To let the site know where you are, choose Allow. Before sharing your location, review the site's privacy policy.": "By default, Chrome asks you when a site wants to see your location. To let the site know where you are, choose Allow. Before sharing your location, review the site's privacy policy.",
    " Settings.": " Settings.",
    "Your Cart": "Your Cart",
    "No Destination found": "No Destination found",
    "Site settings.": "Site settings.",
    "On your Android phone or tablet, open the Chrome app ": "On your Android phone or tablet, open the Chrome app ",
    "Tap ": "Tap ",
    "Your details": "Your details",
    "Under \"Privacy and security,\" click ": "Under \"Privacy and security,\" click ",
    "iPhone & iPad": "iPhone & iPad",
    "Click ": "Click ",
    "We'd love to hear from you.": "We'd love to hear from you.",
    "To the right of the address bar, tap More ": "To the right of the address bar, tap More ",
    "Payment": "Payment",
    "All Destinations": "All Destinations",
    "NO RETURNS, CHANGES OR CANCELLATIONS ARE ALLOWED": "NO RETURNS, CHANGES OR CANCELLATIONS ARE ALLOWED",
    "Highest Price": "Highest Price",
    "Range Prices": "Range Prices",
    "The Free Tour is the one of equal or lesser value to the others and your savings is automatically calculated and shown at checkout just before you finalize your purchase online. Or, you may contact us to make your reservation on phone, we will review the pricing and details with you when we make your booking.": "The Free Tour is the one of equal or lesser value to the others and your savings is automatically calculated and shown at checkout just before you finalize your purchase online. Or, you may contact us to make your reservation on phone, we will review the pricing and details with you when we make your booking.",
    "<strong>Book 3 Different Tours - ALL MUST BE FROM THOSE LISTED AND SHOWN AS \"Valid 3<sup class=\"t_low\">rd</sup> Tour Free\" on the promotion page.</strong>": "<strong>Book 3 Different Tours - ALL MUST BE FROM THOSE LISTED AND SHOWN AS \"Valid 3<sup class=\"t_low\">rd</sup> Tour Free\" on the promotion page.</strong>",
    "Filters": "Filters",
    "ALL participants on the reservation must be doing the exact same 3 tours...otherwise, make separate reservations when the selections vary by participant.": "ALL participants on the reservation must be doing the exact same 3 tours...otherwise, make separate reservations when the selections vary by participant.",
    "FILTERS": "FILTERS",
    "<strong>3<sup class='t_low'>rd</sup> Tour FREE!</strong>": "<strong>3<sup class='t_low'>rd</sup> Tour FREE!</strong>",
    "3<sup>rd</sup> Tour FREE!": "3<sup>rd</sup> Tour FREE!",
    "<strong>Here's How 3<sup class='t_low'>rd</sup> Tour Free Promo Works</strong>": "<strong>Here's How 3<sup class='t_low'>rd</sup> Tour Free Promo Works</strong>",
    "All": "All",
    "FILTER BY": "FILTER BY",
    "IMPORTANT RULES/RESTRICTIONS": "IMPORTANT RULES/RESTRICTIONS",
    "SEE ALL 3<sub class='t_low'>rd</sub> Tour FREE Activities": "SEE ALL 3<sub class='t_low'>rd</sub> Tour FREE Activities",
    "BOOK ALL 3 TOURS in ONE Reservation through the shopping cart.": "BOOK ALL 3 TOURS in ONE Reservation through the shopping cart.",
    "Only the valid displayed <span class=\"blue_text\"><strong>\"3<sup class=\"t_low\">rd</sup> Tour Free\" </strong></span> activities shown online are valid in this promotion. The promotion rules are for a \"set-offer\" as described, and once booked.": "Only the valid displayed <span class=\"blue_text\"><strong>\"3<sup class=\"t_low\">rd</sup> Tour Free\" </strong></span> activities shown online are valid in this promotion. The promotion rules are for a \"set-offer\" as described, and once booked.",
    "Activity type": "Activity type",
    "ORDER BY": "ORDER BY",
    "NOTE:": "NOTE:",
    "No tours found": "No tours found",
    "Shorter Duration": "Shorter Duration",
    "Longer Duration": "Longer Duration",
    "Filter": "Filter",
    "What you are looking?": "What you are looking?",
    "Lowest Price": "Lowest Price",
    "Tours found": "Tours found",
    "All listed prices include taxes": "All listed prices include taxes",
    "Ver más": "Ver más",
    "See All Experiences": "See All Experiences",
    "Only on {{brandname}}!": "Only on {{brandname}}!",
    "SEE NOW!": "SEE NOW!",
    "See our best tour places at {{brandname}}": "See our best tour places at {{brandname}}",
    "You won't find it cheaper online or anywhere else!": "You won't find it cheaper online or anywhere else!",
    "Our providers are hand-picked, safe and reliable, so you always get what you pay for.": "Our providers are hand-picked, safe and reliable, so you always get what you pay for.",
    "Why <span class='blue_text'>book ahead</span>?": "Why <span class='blue_text'>book ahead</span>?",
    "Most <br />Popular <br /> Tours": "Most <br />Popular <br /> Tours",
    "Don't be disappointed": "Don't be disappointed",
    "The best <br />Water Tours": "The best <br />Water Tours",
    "Save time & money": "Save time & money",
    "When you book ahead, you are guaranteed not to miss out on popula tours & activities.": "When you book ahead, you are guaranteed not to miss out on popula tours & activities.",
    "Travel with confidence": "Travel with confidence",
    "México & the Caribbean": "México & the Caribbean",
    "from": "from",
    "Cart": "Cart",
    "Store": "Store",
    "Checkout": "Checkout",
    "MEXICO": "MEXICO",
    "Experiences": "Experiences",
    "All Experiences": "All Experiences",
    "Enter Your Email": "Enter Your Email",
    "Language": "Language",
    "Go": "Go",
    "Need help with experiences?": "Need help with experiences?",
    "To add this tour to your wish list  you must log in": "To add this tour to your wish list  you must log in",
    "Login": "Login",
    "Booking": "Booking",
    "Limited availability": "Limited availability",
    "There are 24 hours left with this rate": "There are 24 hours left with this rate",
    "Our Vacation Concierge is available.": "Our Vacation Concierge is available.",
    "{{qty}} people booked in the last 24 hours": "{{qty}} people booked in the last 24 hours",
    "Booked {{qty}} times in the last 6 hours": "Booked {{qty}} times in the last 6 hours",
    "Weekend preference, high demand": "Weekend preference, high demand",
    "Only {{qty}} tickets of this type are available in {{brandname}}": "Only {{qty}} tickets of this type are available in {{brandname}}",
    "OFFER": "OFFER",
    "Everyday from 9:00am to 6:00pm Central": "Everyday from 9:00am to 6:00pm Central",
    "There are {{qty}} more users watching this activity": "There are {{qty}} more users watching this activity",
    "This activity is ready to close due to space limit": "This activity is ready to close due to space limit",
    "Special sale": "Special sale",
    "Booked {{qty}} times in the last 24 hours": "Booked {{qty}} times in the last 24 hours",
    "Rules & Things": "Rules & Things",
    "Activity Date": "Activity Date",
    "Persons": "Persons",
    "Children ({{minage}}+) Adult Price": "Children ({{minage}}+) Adult Price",
    "Children under ({{minage}}) are not allowed": "Children under ({{minage}}) are not allowed",
    "Rates are per {{pricetype}} in {{currency}}": "Rates are per {{pricetype}} in {{currency}}",
    "Select Adults": "Select Adults",
    "Time": "Time",
    "Coupon Code": "Coupon Code",
    "Adults": "Adults",
    "Children": "Children",
    "Date": "Date",
    "Select Children": "Select Children",
    "Validate Coupon": "Validate Coupon",
    "TOTAL": "TOTAL",
    "Check out now": "Check out now",
    "Last minute offer": "Last minute offer",
    "Valid 3rd Experience Free": "Valid 3rd Experience Free",
    "Only {{qty}} places left": "Only {{qty}} places left",
    "Book online <span class=\"blue_text\">or call</span>": "Book online <span class=\"blue_text\">or call</span>",
    "PEOPLE ALSO LIKE": "PEOPLE ALSO LIKE",
    "Highlights": "Highlights",
    "Experience Description": "Experience Description",
    "High demand we have few places": "High demand we have few places",
    "Add to Cart": "Add to Cart",
    "We have only {{qty}} tickets": "We have only {{qty}} tickets",
    "Map": "Map",
    "Our Vacation Concierge is available Everyday from 9:00am to 6:00pm Central Time, to answer your questions.": "Our Vacation Concierge is available Everyday from 9:00am to 6:00pm Central Time, to answer your questions.",
    "No experiences found": "No experiences found",
    "mexicofooter": "mexicofooter",
    "<strong>3<sup class='t_low'>rd</sup> Experience FREE!</strong>": "<strong>3<sup class='t_low'>rd</sup> Experience FREE!</strong>",
    "3<sup>rd</sup> Experience FREE!": "3<sup>rd</sup> Experience FREE!",
    "Experience & ACTIVITES in": "Experience & ACTIVITES in",
    "3rd Experience Free": "3rd Experience Free",
    "The Free Experience is the one of equal or lesser value to the others and your savings is automatically calculated and shown at checkout just before you finalize your purchase online. Or, you may contact us to make your reservation on phone, we will review the pricing and details with you when we make your booking.": "The Free Experience is the one of equal or lesser value to the others and your savings is automatically calculated and shown at checkout just before you finalize your purchase online. Or, you may contact us to make your reservation on phone, we will review the pricing and details with you when we make your booking.",
    "ALL participants on the reservation must be doing the exact same 3 experiences...otherwise, make separate reservations when the selections vary by participant.": "ALL participants on the reservation must be doing the exact same 3 experiences...otherwise, make separate reservations when the selections vary by participant.",
    "SEE ALL 3<sub class='t_low'>rd</sub> Experience FREE Activities": "SEE ALL 3<sub class='t_low'>rd</sub> Experience FREE Activities",
    "Only the valid displayed <span class=\"blue_text\"><strong>\"3<sup class=\"t_low\">rd</sup> Experience Free\" </strong></span> activities shown online are valid in this promotion. The promotion rules are for a \"set-offer\" as described, and once booked.": "Only the valid displayed <span class=\"blue_text\"><strong>\"3<sup class=\"t_low\">rd</sup> Experience Free\" </strong></span> activities shown online are valid in this promotion. The promotion rules are for a \"set-offer\" as described, and once booked.",
    "BOOK ALL 3 EXPERIENCES in ONE Reservation through the shopping cart.": "BOOK ALL 3 EXPERIENCES in ONE Reservation through the shopping cart.",
    "<strong>Here's How 3<sup class='t_low'>rd</sup> Experience Free Promo Works</strong>": "<strong>Here's How 3<sup class='t_low'>rd</sup> Experience Free Promo Works</strong>",
    "Navigation": "Navigation",
    "We are a company focused on providing the best customer experience through our family of ambassadors and our algorithms that allow us to sell, commission and monitor in an interactive way.": "We are a company focused on providing the best customer experience through our family of ambassadors and our algorithms that allow us to sell, commission and monitor in an interactive way.",
    "<strong>Book 3 Different Experiences - ALL MUST BE FROM THOSE LISTED AND SHOWN AS \"Valid 3<sup class=\"t_low\">rd</sup> Experience Free\" on the promotion page.</strong>": "<strong>Book 3 Different Experiences - ALL MUST BE FROM THOSE LISTED AND SHOWN AS \"Valid 3<sup class=\"t_low\">rd</sup> Experience Free\" on the promotion page.</strong>",
    "Explore": "Explore",
    "Explore <br /> the seabed": "Explore <br /> the seabed",
    " The Best <span class=\"blue_text\"><b>activities for you</b></span>": " The Best <span class=\"blue_text\"><b>activities for you</b></span>",
    " The Best <span class=\"blue_text\">Experiences</span>": " The Best <span class=\"blue_text\">Experiences</span>",
    "Drive and dare <br /> to travel the best roads": "Drive and dare <br /> to travel the best roads",
    "Dinner and <br /> have a quiet evening": "Dinner and <br /> have a quiet evening",
    " The Best <br/>Experiences": " The Best <br/>Experiences",
    "Live  <br /> and cultivate": "Live  <br /> and cultivate",
    "Enjoy <br /> the best environment": "Enjoy <br /> the best environment",
    "Discover the most outstanding": "Discover the most outstanding",
    "When you book ahead, you are guaranteed not to miss out on popula experiences & activities.": "When you book ahead, you are guaranteed not to miss out on popula experiences & activities.",
    "Quick booking": "Quick booking",
    " The most <br/>Popular": " The most <br/>Popular",
    "Discover and plan your trip": "Discover and plan your trip",
    "Excitement <br /> to the fullest": "Excitement <br /> to the fullest",
    "Master <br /> your skills": "Master <br /> your skills",
    "Welcome to <span class=\"blue_text\"><b>{{brandname}}</b></span>, the best place where we give you the best experiences. Explore our destinations and discover the options we have for you.": "Welcome to <span class=\"blue_text\"><b>{{brandname}}</b></span>, the best place where we give you the best experiences. Explore our destinations and discover the options we have for you.",
    " Why should <span class=\"blue_text\"><b>you choose us</b></span>": " Why should <span class=\"blue_text\"><b>you choose us</b></span>",
    "Dare to have <br /> an extreme adventure": "Dare to have <br /> an extreme adventure",
    "Family <br /> fun": "Family <br /> fun",
    "Dive and learn <br /> about the best of the ocean": "Dive and learn <br /> about the best of the ocean",
    "Know the best <br /> of our culture": "Know the best <br /> of our culture",
    "Have a magical  <br /> and unique adventure": "Have a magical  <br /> and unique adventure",
    "Reviews": "Reviews",
    "Transportation Included from Hotel": "Transportation Included from Hotel",
    "Tour Description": "Tour Description",
    "Child": "Child",
    "Children Ages": "Children Ages"
}